export default __webpack_public_path__ + "static/media/reven.1f8165e2.png";